import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('groups/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('groups/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('groups/edit', val_id);
  }

  detail(val_id: number) {
    return this.restService.get('groups/detail', val_id);
  }

  auditing(val_id: number) {
    return this.restService.get('groups/auditing', val_id);
  }

  confirmDeparture(val_id: number, data: any) {
    return this.restService.update('groups/confirm/departure', val_id, data);
  }

  resetStatusDeparture(val_id: number, data: any) {
    return this.restService.update('groups/reset/departure', val_id, data);
  }

  save(data: any) {
    return this.restService.save('groups/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('groups/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('groups/delete', val_id);
  }

  // validations 
  validateTransportGroup(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('groups/validate/transport', val_params);
  }
  validateGuideGroup(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('groups/validate/guide', val_params);
  }

  // REPORT DATA
  listReportGroups(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('report/groups/list', val_params);
  }

  saveBalanceGroup(data: any) {
    return this.restService.save('report/groups/save/balance', data);
  }

  guidesProjection(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('groups/guide/projection', val_params);
  }
  
}
